import bootbox from './../common/components/Bootbox/bootbox';
import {t} from './../../systems/i18n/index.js';

export function* listenPermissionNotAllow() {
    bootbox.error(t('error_page.permission_not_allow'))
}